import { render } from "./CustomSelectOneTestType.vue?vue&type=template&id=10889503"
import script from "./CustomSelectOneTestType.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneTestType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__